export default function AdminDashboard() {
    return (
      <div>
        <h1>Admin Dashboard</h1>
        <p>Welcome to your admin overview.</p>
      </div>
    );
  }
  